import * as React from "react"
import { cn } from "@/lib/utils"

export interface AccordionItemProps {
  title: React.ReactNode
  children: React.ReactNode
  defaultOpen?: boolean
}

export function AccordionItem({ title, children, defaultOpen }: AccordionItemProps){
  const [open,setOpen]=React.useState(!!defaultOpen)
  return (
    <div className="border-b border-border py-2">
      <button className="flex w-full items-center justify-between py-2 text-left" onClick={()=>setOpen(o=>!o)}>
        <span>{title}</span>
        <span className="text-xl">{open ? '-' : '+'}</span>
      </button>
      {open && <div className={cn("pb-2 text-sm text-foreground/90")}>{children}</div>}
    </div>
  )
}
